import { MaintenanceWindowFormGzDataProvider } from '../dataProvider/MaintenanceWindowFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MaintenanceWindowFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MaintenanceWindowFormGzDataProvider);
  }
}
